import React from 'react';

import { Link } from 'react-router-dom';
import './aboutbody.css';
import Value from './value';

const AboutBody = () => {
    return (
        <>
            <div className='top-img'>
                <img src={require("../../assets/medicine-capsules-global-health-with-geometric-pattern-digital-remix.jpg")} alt="" />
                <div className="top-content">
                    <h1>About Us</h1>
                    <div className="top-link">
                        <div className='home-link'>  <Link to="/" >Home</Link> </div>
                        <div className='currentpage'>About Us</div>
                    </div>

                </div>

            </div>
            <div className="aboutbody" data-aos="fade-up">
                <div className="content-item">

                    <div className='welcome-content'>

                        <div className="welcome-right">
                            <img src={require("../../assets/colorful-pills-syringe.jpg")} alt="" />

                        </div>

                        <div className="welcome-left">
                            <h2 className='content-title'>Welcome To Rooba Swastha Pharmaceuticals</h2>
                            <p>Rooba Swastha Pharmaceuticals is a growing company dedicated to providing affordable, high-quality generic medicines. We partner with reliable, WHO-GMP & ISO-certified manufacturers to ensure every product meets global quality and safety standards. This strong commitment allows us to deliver medicines that are not only effective but also trusted by healthcare professionals and patients. Our motto, <b>"Affordable Healthcare for All,"</b> drives us to bridge the gap between quality and accessibility, making us a dependable partner in healthcare.</p>


                            <div className="vision-mission">
                                <div className="mission">
                                    <h3>Our Mission</h3>
                                    <img src={require("../../assets/mission new.png")} alt="" />
                                    <p>We are committed to enriching lives by making affordable, high-quality generic medicines
                                        accessible to everyone. By partnering with others, we ensure that cost is never a barrier to
                                        healthcare and that our products contribute to the well-being of patients around the world.</p>
                                </div>

                                <div className="vision">
                                    <h3>Our Vision</h3>
                                    <img src={require("../../assets/vision new.png")} alt="" />
                                    <p>Our vision is to lead the future of generic medicines by setting new standards for
                                        affordability, quality, and accessibility. We envision a world where everyone has access to
                                        safe and effective medications, empowering healthier communities and a brighter tomorrow.</p>
                                </div>
                            </div>
                        </div>








                    </div>



                </div>
            </div>

            <Value />





        </>
    );
}

export default AboutBody;
